var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReactRouter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 144,
    height: 28,
    role: "img",
    "aria-label": "REACT ROUTER",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "REACT ROUTER") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    shapeRendering: "crispEdges"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 28,
    fill: "#000000"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    textAnchor: "middle",
    fontFamily: "Verdana,Geneva,DejaVu Sans,sans-serif",
    textRendering: "geometricPrecision",
    fontSize: 100
  }, /*#__PURE__*/React.createElement("image", {
    x: 9,
    y: 7,
    width: 14,
    height: 14,
    xlinkHref: "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjQ0E0MjQ1IiByb2xlPSJpbWciIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48dGl0bGU+UmVhY3QgUm91dGVyPC90aXRsZT48cGF0aCBkPSJNMTIuMTE4IDUuNDY2YTIuMzA2IDIuMzA2IDAgMDAtLjYyMy4wOGMtLjI3OC4wNjctLjcwMi4zMzItLjk1My41ODMtLjQxLjQyMy0uNDkuNjA5LS42NjIgMS40NjktLjA4LjQyMy40MSAxLjQzLjg0NyAxLjczNC40NS4zMTcgMS4wODUuNTAyIDIuMDY1LjYwOCAxLjQyOS4xNiAxLjg0LjYzNiAxLjg0IDIuMTk3IDAgMS4zNzctLjM4NSAxLjc0Ny0xLjk2IDEuOTA2LTEuNzA3LjE3Mi0yLjU4LjgzNC0yLjc2NSAyLjExNy0uMTA2Ljc4MS40MSAxLjc2IDEuMTI1IDIuMDkxIDEuNjI3Ljc2OCAzLjE1LS4xOTggMy40NjctMi4xOTYuMjExLTEuMjg0LjYyMi0xLjY0MiAxLjk5OC0xLjc0NyAxLjU4OC0uMTMzIDIuNDA5LS42NzUgMi43MTMtMS43ODcuMjc4LTEuMDItLjMwNC0yLjE1Ny0xLjI5Ny0yLjU1NC0uMjY0LS4xMDYtLjg3My0uMjM4LTEuMzUtLjI5MS0xLjQ5NS0uMTYtMS44NzktLjQyNC0yLjAzOC0xLjM5LS4yMjUtMS4zMzctLjMxNy0xLjU2Mi0uNzk0LTIuMDlhMi4xNzQgMi4xNzQgMCAwMC0xLjYxMy0uNzN6bS00Ljc4NSA0LjM2YTIuMTQ1IDIuMTQ1IDAgMDAtLjQ5Ny4wNDhjLTEuNDY5LjMxOC0yLjE3IDIuMDUxLTEuMzUgMy4yOTUgMS4xNzggMS43NzQgMy45NDQuOTUzIDMuOTctMS4xNzcuMDEyLTEuMTkzLS45OC0yLjE0My0yLjEyMy0yLjE2NnpNMi4wODkgMTQuMTlhMi4yMiAyLjIyIDAgMDAtLjQyNy4wNTJjLTIuMTU4LjQ3Ni0yLjIzNyAzLjYyNi0uMTA2IDQuMTgyLjUzLjE0NS41ODIuMTQ1IDEuMTExLjAxMyAxLjE5MS0uMzE4IDEuODY2LTEuNDU2IDEuNTQ5LTIuNjA3LS4yNzgtMS4wMi0xLjE0NC0xLjY2NC0yLjEyNy0xLjY0em0xOS44MjQuMDA4Yy0uMjMzLjAwMi0uNDc3LjA1OC0uNzg0LjE2Mi0xLjM5LjQ3Ny0xLjg2NiAyLjA5Mi0uOTggMy4zMzYuNTU3Ljc5NCAxLjk2IDEuMDU4IDIuODIuNTE2IDEuNDE2LS44NzQgMS4zNjMtMy4wNTctLjA5My0zLjc0Ni0uMzgtLjE4Ni0uNjYzLS4yNzEtLjk2My0uMjY4eiIvPjwvc3ZnPg=="
  }), /*#__PURE__*/React.createElement("text", {
    transform: "scale(.1)",
    x: 820,
    y: 175,
    textLength: 1000,
    fill: "#fff",
    fontWeight: "bold"
  }, "REACT ROUTER"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactRouter);
export default __webpack_public_path__ + "static/media/react-router.49ba25433e4259e9129fa1fa04e747f2.svg";
export { ForwardRef as ReactComponent };